import { digitGroup } from 'src/helpers/index'

export default function () {
  return {
    table: {
      profitLoss: {
        visibleColumns: [],

        columns: [
          {
            name: 'do_no',
            field: (row) => {
              return row.do_no
            },
            label: 'No. Delivery Order',
            sortable: true,
            align: 'left',
            rowClass: 'text-left'
          },
          {
            name: 'do_created_at',
            field: 'do_created_at',
            label: 'Tgl Pembuatan DO',
            sortable: true,
            align: 'left',
            rowClass: 'text-left',
            commonDate: true
          },
          {
            name: 'customer_company_type',
            field: 'customer_company_type',
            label: 'Jenis Perusahaan',
            sortable: true,
            align: 'left',
            rowClass: 'text-left'
          },
          {
            name: 'customer_name',
            field: (row) => {
              return row.customer_name
            },
            label: 'Customer',
            sortable: true,
            align: 'left',
            rowClass: 'text-left'
          },
          {
            name: 'customer_type',
            field: 'customer_type',
            label: 'Jenis Customer',
            sortable: true,
            align: 'left',
            rowClass: 'text-left text-primary'
          },

          {
            name: 'product_name',
            field: (row) => {
              if (row.variant && row.variant.length) {
                const variant = row.variant.map((item) => {
                  return `<div class="q-badge flex inline items-center no-wrap q-badge--single-line bg-grey-3 text-dark q-mr-xs q-mb-xs">${item.value}</div>`
                })
                return `<div>${row.product_name}</div>
                  <div class="flex items-center wrap q-mt-xs">
                    <strong>${variant.join('')}</stron>
                  </div>
                `
              } else {
                return '-'
              }
            },
            label: 'Nama Produk',
            sortable: true,
            align: 'left',
            rowClass: 'text-left td-width-medium'
          },
          {
            name: 'category_1',
            field: (row) => (row.category_1 ? row.category_1 : '-'),
            label: 'Kategori 1',
            sortable: true,
            align: 'left',
            rowClass: 'text-left'
          },
          {
            name: 'category_2',
            field: (row) => (row.category_2 ? row.category_2 : '-'),
            label: 'Kategori 2',
            sortable: true,
            align: 'left',
            rowClass: 'text-left'
          },
          {
            name: 'category_3',
            field: (row) => (row.category_3 ? row.category_3 : '-'),
            label: 'Kategori 3',
            sortable: true,
            align: 'left',
            rowClass: 'text-left'
          },
          {
            name: 'brand',
            field: (row) => (row.brand ? row.brand : '-'),
            label: 'Merek',
            sortable: true,
            align: 'left',
            rowClass: 'text-left'
          },

          {
            name: 'qty',
            field: (row) => (row.qty ? row.qty : '-'),
            label: 'Jumlah DO',
            sortable: true,
            align: 'left',
            rowClass: 'text-left'
          },
          {
            name: 'price_non_ppn',
            field: 'price_non_ppn',
            label: 'Harga DO (Exc)',
            sortable: true,
            align: 'left',
            inRupiah: true,
            rowClass: 'text-left text-no-wrap'
          },
          {
            name: 'price_ppn',
            field: 'price_ppn',
            label: 'Harga DO (Inc PPN)',
            sortable: true,
            align: 'left',
            inRupiah: true,
            rowClass: 'text-left text-no-wrap'
          },
          {
            name: 'total_do_non_ppn',
            field: 'total_do_non_ppn',
            label: 'Total DO (Exc)',
            sortable: true,
            align: 'left',
            inRupiah: true,
            rowClass: 'text-left text-no-wrap'
          },
          {
            name: 'total_do_ppn',
            field: 'total_do_ppn',
            label: 'Total DO (Inc PPN)',
            sortable: true,
            align: 'left',
            inRupiah: true,
            rowClass: 'text-left text-no-wrap'
          },

          {
            name: 'do_paid_status',
            field: (row) => {
              let color, text
              switch (row.do_paid_status) {
                case 'PAID':
                  color = 'bg-teal-1 text-primary'
                  text = 'Sudah Dibayar'
                  break
                case 'UNPAID':
                  color = 'bg-red-1 text-negative'
                  text = 'Belum Dibayar'
                  break
              }

              return `<div class="q-badge flex inline items-center no-wrap q-badge--single-line ${color}">
                <strong>${text}</strong>
              </div>`
            },
            label: 'Status Bayar DO',
            sortable: true,
            align: 'left',
            rowClass: 'text-left'
          },

          {
            name: 'payment_date',
            field: 'do_paid_at',
            label: 'Tanggal Pembayaran',
            sortable: true,
            align: 'left',
            commonDate: true,
            rowClass: 'text-left'
          },

          {
            name: 'po_no',
            field: 'po_no',
            label: 'No. Purchase Order',
            sortable: true,
            align: 'left',
            rowClass: 'text-left'
          },
          {
            name: 'po_created_at',
            field: 'po_created_at',
            label: 'Tanggal PO Dibuat',
            sortable: true,
            align: 'left',
            commonDate: true,
            rowClass: 'text-left'
          },

          {
            name: 'supplier_name',
            field: 'supplier_name',
            label: 'Vendor',
            sortable: true,
            align: 'left',
            rowClass: 'text-left td-width-small'
          },
          {
            name: 'vendor_category',
            field: (row) => (row.vendor_category ? row.vendor_category : '-'),
            label: 'Kategori Vendor',
            sortable: true,
            align: 'left',
            rowClass: 'text-left'
          },
          {
            name: 'vendor_ppn',
            field: 'vendor_ppn',
            label: 'Vendor PPN / Non PPN',
            sortable: true,
            align: 'left',
            rowClass: 'text-left'
          },
          {
            name: 'po_qty',
            field: 'po_qty',
            label: 'Jumlah PO',
            sortable: true,
            align: 'left',
            rowClass: 'text-left'
          },
          {
            name: 'po_price_non_ppn',
            field: 'po_price_non_ppn',
            label: 'Harga PO (Exc)',
            sortable: true,
            align: 'left',
            inRupiah: true,
            rowClass: 'text-left text-no-wrap'
          },
          {
            name: 'po_price_ppn',
            field: 'po_price_ppn',
            label: 'Harga PO (Inc PPN)',
            sortable: true,
            align: 'left',
            inRupiah: true,
            rowClass: 'text-left text-no-wrap'
          },
          {
            name: 'total_po_non_ppn',
            field: 'total_po_non_ppn',
            label: 'Total PO (Exc)',
            sortable: true,
            align: 'left',
            inRupiah: true,
            rowClass: 'text-left text-no-wrap'
          },
          {
            name: 'total_po_ppn',
            field: 'total_po_ppn',
            label: 'Total PO (Inc)',
            sortable: true,
            align: 'left',
            inRupiah: true,
            rowClass: 'text-left text-no-wrap'
          },

          {
            name: 'po_payment_status',
            field: (row) => {
              let color, text
              switch (row.po_payment_status) {
                case 'PAID':
                  color = 'bg-teal-1 text-primary'
                  text = 'Sudah Dibayar'
                  break
                case 'UNPAID':
                  color = 'bg-red-1 text-negative'
                  text = 'Belum Dibayar'
                  break
              }

              return `<div class="q-badge flex inline items-center no-wrap q-badge--single-line ${color}">
                <strong>${text}</strong>
              </div>`
            },
            label: 'Status Bayar PO',
            sortable: true,
            align: 'left',
            rowClass: 'text-left'
          },
          {
            name: 'po_payment_at',
            field: 'po_payment_at',
            label: 'Tanggal Bayar PO',
            sortable: true,
            align: 'left',
            rowClass: 'text-left',
            commonDate: true
          },

          {
            name: 'total_gp',
            field: (row) => {
              let preText, color
              switch (true) {
                case row.total_gp < 0:
                  preText = '- Rp'
                  color = 'text-negative'
                  break

                case row.total_gp > 0:
                  preText = '+ Rp'
                  color = 'text-primary'
                  break

                case row.total_gp === 0:
                default:
                  preText = '-'
                  color = ''
                  break
              }
              return `<div class="${color}">
                <strong>
                  ${preText} ${digitGroup(Math.abs(row.total_gp))}
                </strong>
              </div>`
            },
            label: 'Total GP',
            sortable: true,
            align: 'left',
            rowClass: 'text-left text-no-wrap'
          },
          {
            name: 'gp_presentase',
            field: (row) => {
              let text, color
              switch (true) {
                case row.gp_presentase < 0:
                  text = `-${Math.abs(row.gp_presentase)}%`
                  color = 'text-negative'
                  break

                case row.gp_presentase > 0:
                  text = `+${Math.abs(row.gp_presentase)}%`
                  color = 'text-primary'
                  break

                case row.gp_presentase === 0:
                default:
                  text = '-'
                  color = ''
                  break
              }
              return `<div class="${color}">
                <strong>
                  ${text}
                </strong>
              </div>`
            },
            label: 'GP%',
            sortable: true,
            align: 'left',
            rowClass: 'text-left'
          }
        ]
      }
    }
  }
}
